module.exports = __webpack_public_path__ + "img/note.1202eaf5.svg";